export const CONNECT_PROFILE = {
  name: 'Tom Lo',
  title: 'Director',
  company: 'Lokyis Ltd',
  intro: 'Websites & apps for local businesses.',
  phoneDisplay: '+44 7469 043367',
  phoneHref: 'tel:+447469043367',
  whatsappHref: 'https://wa.me/447469043367',
  email: 'contact@lokyis.com',
  website: 'https://lokyis.com/',
  vcardHref: `${process.env.PUBLIC_URL}/tom-lo.vcf`,
  vcardFilename: 'tom-lo.vcf',
  instagram: 'https://www.instagram.com/lokyis_official/',
  facebook: 'https://www.facebook.com/profile.php?id=61590353682187',
  enquiry: 'Have a website or app project in mind? Let’s talk.',
};

/** Verified projects only — company products vs client work are labelled in the UI. */
export const CONNECT_WORK = [
  {
    id: 'faithful-living',
    kind: 'Client website',
    name: 'Faithful Living',
    summary: 'Website redesign for a Southfields wellbeing practice — sessions, reviews, location and booking made clearer on phone and desktop.',
    href: 'https://faithful-living.com/',
    image: `${process.env.PUBLIC_URL}/work/faithful-living-website.jpg`,
    imageAlt: 'Screenshot of the Faithful Living website homepage',
  },
  {
    id: 'procoview',
    kind: 'Lokyis product',
    name: 'ProcoView',
    summary: 'Instant replay and video review for court sports — available on the App Store for iPhone.',
    href: 'https://apps.apple.com/gb/app/procoview/id6797191144',
    image: `${process.env.PUBLIC_URL}/products/procoview-icon.jpg`,
    imageAlt: 'ProcoView app icon',
  },
  {
    id: 'bring-one-home',
    kind: 'Lokyis product',
    name: 'Bring One Home',
    summary: 'Community-powered lost and found — a simple, safer way to reunite belongings with the people who miss them.',
    href: 'https://bringonehome.com/',
    image: `${process.env.PUBLIC_URL}/products/bring-one-home-mark.png`,
    imageAlt: 'Bring One Home mark',
  },
];
